export enum FeatureTypeEnum {
  MaxEvents = "MaxEvents",
  MaxGalleriesPerEvent = "MaxGalleriesPerEvent",
  MaxPhotosPerGallery = "MaxPhotosPerGallery",
  MaxPhotoSize = "MaxPhotoSize",
  UseFacialRecognition = "UseFacialRecognition",
  AllowBulkUpload = "AllowBulkUpload",
  AllowPhotoExport = "AllowPhotoExport",
  AllowApiAccess = "AllowApiAccess",
}